module.exports = __webpack_public_path__ + "img/wfzs-icon.8ae6ad2.svg";